import axios from 'axios'

// 请求后端接口的代码
export function addData(data) {
  return new Promise((resolve, reject) => {
    axios.post(process.env.VUE_APP_POST_CALLBACK,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data;'
          // 这里要把content-type设置为multipard/form-data，同时还要设置boundary
        }
      }).then(result => {
      resolve(result.data)
    }).catch(err => {
      reject(err)
    })
  })
}
